import { render, staticRenderFns } from "./GSMoreMemberBtn.vue?vue&type=template&id=18169920"
import script from "./GSMoreMemberBtn.vue?vue&type=script&lang=js"
export * from "./GSMoreMemberBtn.vue?vue&type=script&lang=js"
import style0 from "./GSMoreMemberBtn.vue?vue&type=style&index=0&id=18169920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports